import conditioneleVragen from '../../../../../../modules/VerzekeringsInzicht/App/conditioneleVragen.js';

const werkgeverSalaris = {
	init() {
		conditioneleVragen.init();
	},
};

export default werkgeverSalaris;
